<template>
  <div id="div-tabela-kpis-ressarcimento-by-municipio">
    <div v-if="loading" class="loading-overlay">
      <v-progress-circular indeterminate color="primary" size="32" />
    </div>
    <v-text-field
      v-if="numMunicipios > 10"
      v-model="search"
      append-icon="mdi-magnify"
      class="ml-auto mb-5 break-search"
      label="Procurar"
      hide-details
      single-line
    />
    <v-data-table
      class="data-table-kpis"
      dense
      :headers="headers"
      :items="items"
      :search="search"
      :items-per-page="10"
      no-data-text="Nenhum registro disponível"
      no-results-text="Nenhum registro correspondente encontrado"
    >
      <template v-for="h in headers" v-slot:[`header.${h.value}`]="{ header }">
        <v-tooltip bottom v-if="traducaoIndicadores[h.value] != null">
          <template v-slot:activator="{ on }">
            <span v-on="on">{{ h.text }}</span>
          </template>
          <span>{{ traducaoIndicadores[h.value] }}</span>
        </v-tooltip>
        <span v-else>{{ h.text }}</span>
      </template>

      <template v-slot:[`item.incidencia_suspensoes_indevidas`]="{ item }">
        {{
          item.incidencia_suspensoes_indevidas | parseNumberToFloatBrIgnoringNaN
        }}
      </template>
      <template v-slot:[`item.qtnd_total_suspensoes_indevidas`]="{ item }">
        {{
          item.qtnd_total_suspensoes_indevidas | parseNumberToFloatBrIgnoringNaN
        }}
      </template>
      <template v-slot:[`item.percentual_servicos_fora_prazo`]="{ item }">
        {{
          item.percentual_servicos_fora_prazo | parseNumberToFloatBrIgnoringNaN
        }}%
      </template>
      <template v-slot:[`item.qntd_servicos_descumpridos`]="{ item }">
        {{ item.qntd_servicos_descumpridos | parseNumberToFloatBrIgnoringNaN }}
      </template>
      <template v-slot:[`item.qntd_servicos_realizados`]="{ item }">
        {{ item.qntd_servicos_realizados | parseNumberToFloatBrIgnoringNaN }}
      </template>
    </v-data-table>
  </div>
</template>

<script>
export default {
  name: "KpisByMunicipioDataTable",
  props: {
    dadosKpisByMunicipio: {
      type: Object,
      required: true,
    },
    traducaoIndicadores: {
      type: Object,
      default: () => ({}),
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },
  data: () => ({
    headers: [
      {
        text: "IBGE",
        value: "codigo_municipio",
        width: "100px",
      },
      {
        text: "Município",
        value: "nome_municipio",
        width: "180px",
      },
      {
        value: "incidencia_suspensoes_indevidas",
        text: "Incidência",
        width: "120px",
      },
      {
        value: "qtnd_total_suspensoes_indevidas",
        text: "Qtd. Suspensões",
        width: "140px",
      },
      {
        value: "percentual_servicos_fora_prazo",
        text: "% Fora Prazo",
        width: "120px",
      },
      {
        value: "qntd_servicos_descumpridos",
        text: "Qtd. Descumpridos",
        width: "150px",
      },
      {
        value: "qntd_servicos_realizados",
        text: "Qtd. Realizados",
        width: "130px",
      },
    ],
    search: "",
  }),
  computed: {
    numMunicipios() {
      return this.items ? this.items.length : 0;
    },
    items() {
      if (!this.dadosKpisByMunicipio) return [];
      
      return Object.entries(this.dadosKpisByMunicipio).map(
        ([nomeMunicipio, dados]) => ({
          codigo_municipio: dados.codigo_municipio,
          nome_municipio: nomeMunicipio,
          incidencia_suspensoes_indevidas:
            dados.incidencia_suspensoes_indevidas,
          qtnd_total_suspensoes_indevidas:
            dados.qtnd_total_suspensoes_indevidas,
          percentual_servicos_fora_prazo: dados.percentual_servicos_fora_prazo,
          qntd_servicos_descumpridos: dados.qntd_servicos_descumpridos,
          qntd_servicos_realizados: dados.qntd_servicos_realizados,
        })
      );
    },
  },
  methods: {},
};
</script>

<style>
#div-tabela-kpis-ressarcimento-by-municipio {
  min-height: 420px;
  position: relative;
}
.loading-overlay {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 1000;
  background: rgba(255, 255, 255, 0.8);
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 420px;
}
.data-table-kpis table tbody tr td {
  font-size: 12px;
  padding: 0px 8px !important;
}
.data-table-kpis table thead tr th {
  font-size: 12px;
  height: 25px;
  font-weight: 400;
}
</style>
